'use strict';

import React, { Component } from 'react';
import numeral from 'numeral';
import uniqid from 'uniqid';
import Button from '@material-ui/core/Button';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import PaymentSuccess from 'Components/Front/PaymentSuccess';
import PaymentModal from 'Modals/PaymentModal';
import Loader from 'Pure/Loader';
import bemit from 'Functions/bemit';
import { safeNumeral, getUrlParameter } from 'Shared/utilities';
import { SAFERPAY_API, FRONT_ENV } from 'front_env';
import { action } from 'Shared/Routes';
const script_url = SAFERPAY_API + '/Fields/lib/1/saferpay-fields.js';
const {
  qwest,
  app
} = window;
export default class PaymentForm extends Component {
  state = {
    loading: false,
    script_id: 'payment-fields-script',
    ready: window.SaferpayFields ? true : false,
    initializing: false,
    loading_script: window.SaferpayFields ? false : true,
    fields_id: uniqid(),
    modal: false,
    step: 'init'
  };
  ref = React.createRef();
  modal_ref = React.createRef();
  initialized = false;
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.ready) {
      component.setState({
        loading_script: false
      });
      component.initFields();
    } else {
      component.loadScriptIfNeeded();
    }
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (prev_state.ready !== true && state.ready === true) {
      component.initFields();
    }
    if (prev_state.fields_id !== state.fields_id) {
      component.initFields();
    }
  }
  loadScriptIfNeeded = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (component.loading_script || window.SaferpayFields) {
      return component.setState({
        ready: true,
        loading_script: false
      });
    }

    // prevent multiple script load
    component.loading_script = true;
    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('id', state.script_id);
    script.setAttribute('src', script_url);
    script.addEventListener('load', function () {
      if (!window.SaferpayFields) {
        return window.setTimeout(function () {
          component.setState({
            ready: true,
            loading_script: false
          });
        }, 400);
      }
      component.setState({
        ready: true,
        loading_script: false
      });
    });
    script.addEventListener('onError', function (e, error) {
      console.error('error loading fields script', error);
      component.setState({
        loading_script: false,
        error: 'Impossible de charger le kit de paiement.'
      });
    });
    document.body.appendChild(script);
  };
  checkIfLoaded = () => {
    const component = this,
      props = this.props,
      state = this.state;

    // Init callback fired
    if (component.initialized) return false;

    // Init callback not fired after x seconds, trying again
    if (window.SaferpayFields) {
      return component.initFields(true);
    }

    // script loaded but Global object not available, checking later
    window.setTimeout(component.checkIfLoaded, 1000);
  };
  initFields = (force = false) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!force && state.initializing) return;

    // prevent multiple init calls
    component.setState({
      initializing: true
    });
    const API_CUSTOMER_ID = FRONT_ENV !== 'prod' ? '257543' : props.API_CUSTOMER_ID || '308374';
    const TOKEN = FRONT_ENV !== 'prod' ? 'c94637a6-d7da-4f6b-952e-1332356ab773' : props.API_TOKEN || '807d0232-febf-4be5-8e4b-d741a7f5cad0';
    window.SaferpayFields.init({
      accessToken: TOKEN,
      url: SAFERPAY_API + '/Fields/' + API_CUSTOMER_ID,
      style: {
        '.form-control': 'border: none; border-bottom: solid 1px #ccc; border-radius: unset;'
      },
      paymentMethods: ['visa', 'mastercard'],
      onSuccess: function () {
        component.initialized = true;
        component.setState({
          initializing: false
        });
      },
      onError: function (evt) {
        component.initialized = true;
        console.error(evt);
        component.setState({
          initializing: false,
          error: 'Impossible de charger le kit de paiement, veuillez' + ' réessayer'
        });
      },
      placeholders: {
        // Custom Text for Input placeholders
        holdername: 'Nom du titulaire',
        cardnumber: 'Numéro de la carte',
        expiration: 'MM/YY',
        cvc: 'Code (CVC)'
      }
    });

    // check after 4s, the fields should be ready but sometimes it fails silently
    // (i.e without calling onSuccess or onError)
    window.setTimeout(function () {
      component.checkIfLoaded();
    }, 4000);
  };
  handleIframeChange = e => {
    const component = this,
      props = this.props,
      state = this.state;
    const params = e.target?.contentWindow?.location?.search;
    if (!params) return;
    const status = getUrlParameter('paiement', params);
    if (status === 'ok') {
      component.setState({
        step: '3DSecureOK',
        redirect: false,
        modal: false
      });
      component.authorizePayment();
    } else if (status === 'annulation') {
      component.removeFields();
      component.setState({
        step: 'init',
        redirect: false,
        modal: false,
        fields_id: uniqid(),
        error: 'Le 3DSecure est requis pour procéder au paiement.'
      });
    } else if (status === 'echec') {
      component.removeFields();
      component.setState({
        step: 'init',
        redirect: false,
        modal: false,
        fields_id: uniqid(),
        error: 'Échec de la validation 3DSecure, veuillez réessayer.'
      });
    }
  };
  removeFields = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!component.ref?.current) return;
    Array.from(component.ref.current.querySelectorAll('iframe')).forEach(function (iframe) {
      const parent = iframe.parentElement;
      const field_container = document.createElement('div');
      field_container.className = 'c-payment-form__field';
      field_container.setAttribute('id', iframe.getAttribute('id'));
      parent.appendChild(field_container);
      parent.removeChild(iframe);
    });
  };
  validate = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      info: undefined,
      error: undefined,
      warning: undefined
    });

    // Send the entered hosted fields data to Saferpay.
    window.SaferpayFields.submit({
      onSuccess: function (evt) {
        component.setState({
          loading: true
        });
        qwest.post(action('InitSaferPayPayment'), {
          token: evt?.token,
          id: window.localStorage.getItem('current_booking_id')
        }, {
          timeout: 60 * 1000
        }).then(function (xhr, response) {
          const redirect = response.redirect;
          component.setState({
            loading: false,
            redirect: redirect ? true : false,
            redirect_url: redirect,
            modal: redirect ? true : false
          });
          if (!redirect) component.authorizePayment();
        }).catch(function (error, xhr, response) {
          console.error(response?.error || response?.raw || error);
          component.setState({
            ...getErrorsFromResponse({
              response: response
            })
          });
        });
      },
      onError: function (evt) {
        const validation_error = evt?.message?.includes('fields contains invalid or missing data');
        const error = validation_error ? 'Les informations saisies sont incorrectes, veuillez' + ' vérifier votre saisie.' : 'Échec du paiement, veuillez réessayer.';
        component.setState({
          error: error,
          loading: false
        });
      }
    });
  };
  authorizePayment = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      authorizing: true
    });
    qwest.post(action('AuthorizePayment'), {
      id: window.localStorage.getItem('current_booking_id')
    }, {
      timeout: 60 * 1000
    }).then(function (xhr, response) {
      component.setState({
        authorizing: false,
        success: true
      });
      if (typeof props.onSuccess === 'function') {
        props.onSuccess();
      }
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.removeFields();
      component.setState({
        authorizing: false,
        step: 'init',
        redirect: false,
        modal: false,
        fields_id: uniqid(),
        error: response.error || 'Échec du paiement.'
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    numeral.locale('en');
    if (state.success === true) return /*#__PURE__*/React.createElement(PaymentSuccess, null);
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    const init_loader = component.initialized !== true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary'],
      text: "Chargement des informations de paiement..."
    }) : undefined;
    const authorization_loader = state.authorizing === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary'],
      text: "Paiement en cours..."
    }) : undefined;
    const price = window.localStorage.getItem('current_booking_price');
    const btn_disabled = !state.initializing && !component.initialized;
    let output = /*#__PURE__*/React.createElement("div", {
      className: "c-payment-form",
      ref: component.ref
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-payment-form__content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-payment-form__row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-payment-form__item"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-payment-form__field",
      id: "fields-holder-name"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "c-payment-form__row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-payment-form__item"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-payment-form__field",
      id: "fields-card-number"
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-payment-form__item small"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-payment-form__field",
      id: "fields-expiration"
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-payment-form__item small"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-payment-form__field",
      id: "fields-cvc"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "c-payment-form__actions"
    }, getFormStatus(state), /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary'].concat(btn_disabled ? ['disabled'] : [])),
      onClick: component.validate,
      disabled: btn_disabled
    }, "Valider et payer ", numeral(safeNumeral(price)).format('0,0[.]00').split(',').join(' '), "\xA0\u20AC", loader)), init_loader, authorization_loader), /*#__PURE__*/React.createElement(PaymentModal, {
      open: state.modal,
      onClose: () => null
    }, state.modal && state.redirect ? /*#__PURE__*/React.createElement("iframe", {
      className: "c-payment-form__redirect-iframe",
      src: state.redirect_url,
      onLoad: component.handleIframeChange
    }) : /*#__PURE__*/React.createElement("div", {
      className: "c-payment-form__redirect-iframe"
    })));
    return output;
  }
}
